import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ModalController, AlertController } from 'ionic-angular';
import { TakeawayServices } from "../../services";
import { Globals } from "../../../../globals";
import { TakeawayCreateSelectCustomerPage } from '../../takeaway-create/takeaway-create-select-customer/takeaway-create-select-customer';
import { TakeawayOrderPage } from '../../takeaway-order/takeaway-order';
import { PopupErrorsPage } from '../../../components/popups/popup-errors/popup-errors';
import { TranslateService } from '@ngx-translate/core';
import { TakeawayOrdersDeletePage } from '../takeaway-orders-delete/takeaway-orders-delete';
import { TakeawayOrdersRecoverPage } from '../takeaway-orders-recover/takeaway-orders-recover';
import { TakeawaySelectState } from '../../../components/popups/takeaway-select-state/takeaway-select-state';
import { TakeawayOldDeleteOrdersPage } from '../../takeaway-old-delete-orders/takeaway-old-delete-orders';

/**
 * Generated class for the TakeawaySelectOrdersPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-takeaway-select-orders',
  templateUrl: 'takeaway-select-orders.html',
})

export class TakeawaySelectOrdersPage {

  order_asc = false;
  term: string = "";

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public takeawayServices: TakeawayServices,
    public globals: Globals,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    public translate: TranslateService) {
    if (this.takeawayServices.table_takeaway_term) {
      this.term = this.takeawayServices.table_takeaway_term;
      this.takeawayServices.table_takeaway_term = "";
    }

  }

  /**********************************************************/
  /*                        FUNCIONES                       */
  /**********************************************************/

  getDeliveryImage(table) {
    if (table != undefined) {
      const delivery = this.takeawayServices.deliveries.find(t => t.name == table);
      if (delivery != undefined) {
        return delivery.img;
      }
    }
  }

  /**********************************************************/
  /*                         NAVCTRL                        */
  /**********************************************************/

  createTakeaway() {
    this.navCtrl.push(TakeawayCreateSelectCustomerPage);
  }

  async openTicket(index, type, value) {

    //loadingPopup
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();

    //recuperamos la uid de la mesa para abrir la view y de el index correcto
    this.takeawayServices.selected_table_uid = value.UID;
    //Buscamos la informacion del cliente
    var customer_finded = await this.takeawayServices.getCustomer(value.customer_uid);
    //lanzar popup en caso de que cliente no exista (customer_finded -> return de func anterior de si ha encontrado el customer)
    if (!customer_finded) {
      let profileModal = this.modalCtrl.create(PopupErrorsPage, {
        title: this.translate.instant('general-customers'),
        origin: 'tk_customer_noexist',
        msg: this.translate.instant('general-takeaway-mo-tiene-cliente')
      });
      profileModal.onDidDismiss(async data => {
        if (data) {
          if (data.open_change_tk_customer) {
            //getIndexByTableuid
            await this.takeawayServices.getIndexByTableuid();
            //
            this.navCtrl.push(TakeawayCreateSelectCustomerPage, {
              update_state: true,
              uid_table: this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].UID,
            });
          }
        }

      });
      profileModal.present();
    }
    await this.takeawayServices.getIndexByTableuid();
    //info necesaria para abrir el tk
    this.takeawayServices.selected_table_tpv = value;
    this.takeawayServices.selected_type = 'takeaway';
    this.navCtrl.push(TakeawayOrderPage);


    loadingPopup.dismiss();
  }


  deleteTakeaway() {
    this.navCtrl.push(TakeawayOrdersDeletePage);
  }

  recoverTakeaway() {
    this.navCtrl.push(TakeawayOrdersRecoverPage);
  }

  deleteOldOrders() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('tk-eliminar-takeaway'),
      message: this.translate.instant('general-alert-limpiar-ahora-msg'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {

          },
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            //delete
            this.navCtrl.push(TakeawayOldDeleteOrdersPage);
          },
        },
      ],
    });
    alert.present();
  }

  openTakeawaySelectState(table) {
    //abre modal donde enseñaremos las categorias y que seleccione lo que quiere que se muestre(los seleccionades estaran en array)
    let profileModal = this.modalCtrl.create(TakeawaySelectState,
      {
        //title: this.translate.instant('general-selecciona-secciones-mostrar'),
        title: this.translate.instant("general-selecciona-un-estado"),
        table: table,
      });
    profileModal.onDidDismiss(data => {

    });
    profileModal.present();
  }
}


// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-orders/takeaway-select-orders/takeaway-select-orders.ts